import HttpClient from '@smuchile/pkg-unimarc-hooks/shared/HttpClient'

export const updateSalesChannel = async (salesChannel: number) => {
  await HttpClient.getInstance()
    .invoke(
      `${window.location.origin}/api/setCookie?co_sc=${salesChannel}`,
      'POST',
      'setCookie()'
    )
    .then((response) => {
      return response.data
    })
  window.location.reload()
}
